import {RouteObject, RouterContextProvider, redirect} from 'react-router';

import {userEndpoints} from 'src/containers/User';
import {getDispatch} from 'src/routerContext';

import {paymentTabRoutes} from '../../Licenses/PaymentTab/routes';
import {ESupportProfileTabs} from '../definitions';

const checkLicenseAccess = async (context: RouterContextProvider) => {
  const dispatch = getDispatch(context);
  const {data: hasBilling} = await dispatch(userEndpoints.getBillingFlag.initiate());

  return !!hasBilling;
};

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(ESupportProfileTabs.PAYMENT),
  },
  {
    path: ESupportProfileTabs.PAYMENT,
    lazy: async () => ({
      Component: (await import('src/containers/Licenses/PaymentTab')).default,
    }),
    ...paymentTabRoutes,
  },
  {
    path: ESupportProfileTabs.LICENSE,
    lazy: async () => ({
      Component: (await import('src/containers/Licenses/LicensesTab')).default,
    }),
    loader: async ({context}) => {
      const hasAccess = await checkLicenseAccess(context);

      if (!hasAccess) {
        throw redirect(`../${ESupportProfileTabs.PAYMENT}`);
      }
    },
  },
  {
    path: ESupportProfileTabs.REQUISITES,
    lazy: async () => ({
      Component: (await import('src/containers/CompanyDetails')).CompanyDetails,
    }),
  },
  {
    path: ESupportProfileTabs.PRICING,
    lazy: async () => ({
      Component: (await import('./TariffsTab')).TariffsTab,
    }),
  },
  {
    path: ESupportProfileTabs.CONFIGS,
    lazy: async () => ({
      Component: (await import('./ConfigsTab')).default,
    }),
  },
  {
    path: ESupportProfileTabs.USERS,
    lazy: async () => ({
      Component: (await import('src/containers/UserCompanyProfile/UsersTab')).UsersTab,
    }),
  },
];

export const supportClientCardRoutes: RouteObject = {
  loader: async ({context}) => {
    const availableTabs: ESupportProfileTabs[] = Object.values(ESupportProfileTabs);
    const hasLicenseAccess = await checkLicenseAccess(context);

    if (!hasLicenseAccess) {
      return {
        tabs: availableTabs.filter((tab) => tab !== ESupportProfileTabs.LICENSE),
      };
    }

    return {
      tabs: availableTabs,
    };
  },
  children,
};
